import parse from 'html-react-parser';

function onlyUniqueMentionId(value, index, array) {
  return array.indexOf(value) === index;
}

function loopThroughDOMForMentions(obj, findedIds) {
  if (obj == null) return;
  if (Array.isArray(obj)) {
    for (let i = 0; i < obj.length; i += 1) {
      loopThroughDOMForMentions(obj[i], findedIds);
    }
    return;
  }
  if (typeof obj === 'object' && obj.props) {
    if (Object.prototype.hasOwnProperty.call(obj.props, 'children') && obj.props.children !== undefined) {
      loopThroughDOMForMentions(obj.props.children, findedIds);
    }
    if (Object.prototype.hasOwnProperty.call(obj.props, 'data-id')) {
      findedIds.push(obj.props['data-id']);
    }
  }
}

/** Comma-separated user ids from rich-text @mentions (parita ServiceTaskDetail / CustomerBusinessStatusPanel). */
export function extractMentionIdsFromHtml(description) {
  const findedIds = [];
  try {
    const tree = parse(description || '', { trim: true });
    loopThroughDOMForMentions(tree, findedIds);
  } catch (_) {
    /* ignore parse errors */
  }
  return findedIds
    .filter(onlyUniqueMentionId)
    .filter((id) => id != null && String(id).trim() !== '')
    .join(',');
}
